import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-950 text-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="py-14 md:py-16">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap">
                <span className="w-8 h-8 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg font-bold text-sm">
                  安
                </span>
                <span className="font-heading font-semibold text-base text-background-50">
                  安全指南
                </span>
              </Link>
              <p className="text-sm text-background-400 leading-relaxed max-w-xs">
                为成年用户提供专业、可靠的内容安全指导，帮助您做出明智、安全的内容选择决策。
              </p>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-sm text-background-100 mb-4">
                内容分类
              </h4>
              <ul className="flex flex-col gap-2.5">
                {categories.map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-sm text-background-100 mb-4">
                热门文章
              </h4>
              <ul className="flex flex-col gap-2.5">
                <li>
                  <Link
                    to="/article/vpn-guide-safe-browsing"
                    className="text-sm text-background-400 hover:text-background-100 transition-colors"
                  >
                    VPN安全访问完整指南
                  </Link>
                </li>
                <li>
                  <Link
                    to="/article/identify-legitimate-platforms"
                    className="text-sm text-background-400 hover:text-background-100 transition-colors"
                  >
                    辨别正规平台的8个指标
                  </Link>
                </li>
                <li>
                  <Link
                    to="/article/browser-privacy-settings"
                    className="text-sm text-background-400 hover:text-background-100 transition-colors"
                  >
                    浏览器隐私设置终极指南
                  </Link>
                </li>
                <li>
                  <Link
                    to="/article/malware-phishing-prevention"
                    className="text-sm text-background-400 hover:text-background-100 transition-colors"
                  >
                    恶意软件与钓鱼攻击防范
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-sm text-background-100 mb-4">
                关于我们
              </h4>
              <ul className="flex flex-col gap-2.5">
                <li>
                  <Link
                    to="/about"
                    className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap"
                  >
                    品牌介绍
                  </Link>
                </li>
                <li>
                  <Link
                    to="/about"
                    className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap"
                  >
                    联系我们
                  </Link>
                </li>
              </ul>
              <div className="flex items-center gap-3 mt-5">
                <a
                  href="#"
                  className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all"
                  aria-label="Twitter"
                  rel="nofollow"
                >
                  <i className="ri-twitter-x-line text-sm" />
                </a>
                <a
                  href="#"
                  className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all"
                  aria-label="GitHub"
                  rel="nofollow"
                >
                  <i className="ri-github-line text-sm" />
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-background-800 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {currentYear} 安全指南. 本站内容仅供成年人参考，不构成法律建议。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors whitespace-nowrap" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors whitespace-nowrap" rel="nofollow">
              使用条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}